// extracted by mini-css-extract-plugin
module.exports = {"gallery":"section-gallery-module--gallery--1yZPA","content":"section-gallery-module--content--2W_b6","carousel":"section-gallery-module--carousel--2kuqX"};